import React from 'react';
import Component from '@/Component';
import NoDataNode from '@/components/common/NoDataNode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class OutsideTimeNode extends Component {
  onClickRemove() {
    this.props._removeOutside(this.props.START_TIME)
  }

  render() {
    const {
      DATE,
      START_TIME_FORMAT,
      END_TIME_FORMAT
    } = this.props;

    return (
      <tr>
        <td>{DATE.substring(4,6)}/{DATE.substring(6,8)}</td>
        <td>{START_TIME_FORMAT} ~ {END_TIME_FORMAT}</td>
        <td>
          <a onClick={this.onClickRemove}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </a>
        </td>
      </tr>
    )
  }
}

class OutsideTime extends Component {

  render() {
    const {
      outsideList,
      _removeOutside
    } = this.props;

    let nodes;
    if (!outsideList || outsideList.length < 1) {
      nodes = <NoDataNode colSpan={4} />
    } else {
      nodes = outsideList.map((obj, index)=>(
        <OutsideTimeNode key={index} {...obj} _removeOutside={_removeOutside} />
      ))
    }

    return (
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>날짜</th>
            <th>외근시간</th>
            <th>삭제</th>
          </tr>
        </thead>
        <tbody>
          {nodes}
        </tbody>
      </table>
    );
  }
}

export default OutsideTime;



// WEBPACK FOOTER //
// ./src/components/outside/OutsideTime.js